import './App.css';
import Dashboard from './Dashboard/Dashboard';

function App() {
  return (
    <div className="App">
      <Dashboard></Dashboard>
    </div>
  );
}

export default App;
